import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation";
import { getData } from "../../../fetchRoutes/getData";
import PropertyCard from "../../../utility/propertyCard.js";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function MyPropertiesContainer() {
    const myPropertiesUrl = process.env.REACT_APP_WON;

    const [properties, setProperties] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const {isMobile}= useContext(DeviceContext);
    
 

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const propertiesPerPage = isMobile ? 2: 8;

    // Fetch properties
    useEffect(() => {

        async function fetchProperties() {
            setLoading(true);

            try {
                const response = await getData(myPropertiesUrl);
                if (response.status === 'Success') {
                    setProperties(response.data);
                }
            } catch {
                setError('Failed to fetch properties');
            } finally {
                setLoading(false);
            }
        }
        fetchProperties();
    }, [myPropertiesUrl]);

    
  
    // Pagination
    const indexOfLastProperty = currentPage * propertiesPerPage;
    const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
    const currentProperties = properties.slice(indexOfFirstProperty, indexOfLastProperty);

    const totalPages = Math.ceil(properties.length / propertiesPerPage);

    return (
        <main className="sellerDashboard myPropertiesDashboard">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
            <div className={`container ${currentProperties.length === 0 && 'noWinContainer'} ${currentProperties.length <4 && 'moreProperties'}`}>
                <h1 className="containerTitle">MY PROPERTIES</h1>
                <div className={`propertyList ${currentProperties.length === 0 && 'noPropertyList'}`}>
                    {isLoading ? (
                        <div className="loaderContainer">
                            <div className="loader"></div>
                            <p className="loadingText">Loading properties...</p>
                        </div>
                    ) : currentProperties.length > 0 ? (
                        currentProperties.map((property) => (
                            <PropertyCard
                                key={property._id}
                                property={property}
                                won={true}
                               
                            />
                        ))
                    ) : (
                        <div className="noWonPropertiesContainer">
                            <h2 className="noWonPropertiesTitle">You haven't won any properties yet</h2>
                            <p className="noWonPropertiesText">Start bidding on live auctions and win your dream home!</p>
                            <div className="noWonPropertiesActions">
                                <a href="/auctions" className="wonPropertyButton">Browse Live Auctions</a>
                            </div>
                        </div>

                    )}
                    {error && <p className="errorMessage">{error}</p>}
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            disabled={currentPage === 1}
                            className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
                        >
                            Previous
                        </button>

                        <span className="pageInfo">Page {currentPage} of {totalPages}</span>

                        <button
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            disabled={currentPage === totalPages}
                            className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            
        </main>
    );
}
